module.exports = __webpack_public_path__ + "img/logo_fine_white.3b4f7975.png";